export default __webpack_public_path__ + "static/media/2ndBlog.7cf437ff.jpg";